import axiosInstance from "services/AxiosInstance";
import { TQuestionnaireResponsePayload } from "types";

export const postQuestionnaireResponseService = async (payload: TQuestionnaireResponsePayload) => {
  const { accountId, questionnaireRequestId, ...rest } = payload;
  const response = await axiosInstance.post(`/questionnaire/${accountId}/request/${questionnaireRequestId}`, rest);
  return response.data;
};
